import { render, staticRenderFns } from "./ArticleNewsWidget.vue?vue&type=template&id=5c4d9edf&scoped=true&"
import script from "./ArticleNewsWidget.vue?vue&type=script&lang=ts&"
export * from "./ArticleNewsWidget.vue?vue&type=script&lang=ts&"
import style0 from "./ArticleNewsWidget.vue?vue&type=style&index=0&id=5c4d9edf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c4d9edf",
  null
  
)

export default component.exports